/**
 * Mixins
 */
import globals from 'src/helpers/globals'
import { Loading } from 'components/partials/Loading'
import Bus from 'src/helpers/bus'
import Dialog, { UnsubscribedDialog } from 'src/helpers/dialog'
import { Platform, Notify } from 'quasar'

/**
 * Components
 */
import Beta from 'components/partials/Beta.vue'
import PageLayout from './../components/partials/PageLayout'
import PageDrawer from '../components/partials/PageDrawer'
import PageSidebar from '../components/partials/PageSidebar'
import PageToolbarTitle from '../components/partials/PageToolbarTitle'
import PageBanner from '../components/partials/PageBanner'
import AddressField from 'components/partials/address/AddressField.vue'
import PhoneNumber from './../components/partials/PhoneNumber'
import EmailAddress from 'components/partials/EmailAddress.vue'
import WidgetCard from 'components/app/dashboard/partials/Card'
import MorphFab from './../components/partials/MorphFab'
import ProfileImage from './../components/partials/ProfileImage'
import MiraIcon from 'components/partials/mira/MiraIcon'
import MiraLogo from 'components/partials/mira/MiraLogo'
import CancelButton from 'components/partials/buttons/CancelButton'
import Timezones from './../components/partials/Timezones'
import DetailItem from './../components/partials/DetailItem'
import PaymentCards from '../components/partials/payments/Cards'
import FileViewCard from 'components/app/files/partials/files/cards/FileViewCard'
import FileEditCard from 'components/app/files/partials/files/cards/FileEditCard'
import ColorPicker from './../components/partials/colorPicker/ColorPicker'
import ColorField from './../components/partials/colorPicker/ColorField'
import QSelectColorItem from './../components/partials/QSelectColorItem'
import MultiSelect from 'components/partials/MultiSelect'
import QBtnToggleColor from '../components/partials/QBtnToggleColor'
import QItemWrapper from 'components/partials/QItemWrapper'
import MinutePicker from './../components/partials/MinutePicker'
import RruleDialog from '../components/partials/rrule/RruleDialog'
import DatePicker from 'components/partials/dates/DatePicker'
import TimePicker from '../components/partials/TimePicker'
import CountryPicker from 'components/partials/CountryPicker'
import ContentDialog from 'components/partials/dialogs/ContentDialog'
import MessageDialog from 'components/partials/dialogs/MessageDialog'
import StickyHeader from '../components/partials/StickyHeader'
import NoResults from '../components/partials/NoResults'
import LoadingSpinner from '../components/partials/LoadingSpinner'
import ValidatePassword from '../components/partials/ValidatePassword'
import ClickableItem from '../components/partials/ClickableItem'
import TextEditor from '../components/partials/textEditor/TextEditor'
import HelpButton from 'components/partials/buttons/HelpButton'
import WidthAwareContainer from '../components/partials/WidthAwareContainer'
import BasicLink from '../components/partials/BasicLink'
import SignaturePad from '../components/partials/SignaturePad'
import AccountingProvider from 'components/partials/accounting/AccountingProvider'
import SimpleTimeline from 'components/partials/timeline/SimpleTimeline'
import Timeline from 'components/partials/timeline/Timeline'
import Tip from 'components/partials/tips/Tip'
import Articles from 'components/partials/Articles'
import HtmlDialog from 'components/partials/dialogs/HtmlDialog'
import TwoPanelSplit from 'components/partials/TwoPanelSplit'
import FocusView from 'components/partials/focusView/FocusView'
import FocusContainer from 'components/partials/focusView/FocusContainer'
import FocusField from 'components/partials/focusView/FocusField'
import Nl2br from 'components/partials/Nl2br'
import Constraint from 'components/partials/Constraint'
import ResponsiveMenu from 'components/partials/dialogs/ResponsiveMenu'
import StackedBtn from 'components/partials/buttons/StackedBtn.vue'
import QPassword from 'components/partials/QPassword.vue'

import AppointmentItem from './../components/app/calendar/partials/AppointmentItem'
import AppointmentSelectDialog from 'components/app/calendar/partials/SelectAppointmentDialog'
import AppointmentInputPopover from './../components/app/calendar/partials/AppointmentInputPopover'

import ClientInputPopover from './../components/app/clients/partials/ClientInputPopover'
import ClientItem from './../components/app/clients/partials/ClientItem'
import ClientChip from '../components/app/clients/partials/ClientChip'

import UserItem from './../components/app/staff/partials/UserItem'
import UserInputPopover from './../components/app/staff/partials/UserInputPopover'
import UserInput from './../components/app/staff/partials/UserInput'
import UserChip from '../components/app/staff/partials/UserChip'

import TaxTypeSelect from 'components/partials/accounting/TaxTypeSelect'
import LedgerSelect from 'components/partials/accounting/LedgerSelect'

import FileSelectDialog from './../components/app/files/partials/SelectDialog'
import UploaderBtn from 'src/components/partials/uploader/UploaderBtn'

import InvoiceInputPopover from './../components/app/invoicing/partials/InvoiceInputPopover.vue'
import InvoiceChip from './../components/app/invoicing/partials/InvoiceChip.vue'

import ReportItem from './../components/app/reports/partials/ReportItem'
import InvoiceItem from './../components/app/invoicing/partials/InvoiceItem'
import QuotationItem from 'components/app/quotations/partials/QuotationItem'
import Date from 'components/partials/dates/Date'
import DocumentType from './../components/partials/DocumentType'
import CheckboxList from './../components/partials/CheckboxList'
import FormItem from './../components/app/forms/partials/FormItem'
import LicenceItem from 'components/app/staff/licences/partials/LicenceItem'

import InfoTable from '../components/partials/tables/InfoTable'
import DynamicTable from '../components/partials/tables/DynamicTable'

import MetadataViewList from 'components/partials/metadata/ViewList/MetadataViewList'
import MetadataEditList from 'components/partials/metadata/EditList/MetadataEditList'

/**
 * External Components
 */
import VueSignaturePad from 'vue-signature-pad'
import Skycons from 'vue-skycons'
import PortalVue from 'portal-vue'
import VuePapaParse from 'vue-papa-parse'
import { VueReCaptcha } from 'vue-recaptcha-v3'

import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

import 'vue-easy-dnd/dist/dnd.css'
import '@fontsource/barlow'

export default ({ app }) => {
  Notify.setDefaults({
    color: 'blue-grey-10',
    icon: 'mdi-alert-circle-outline',
    timeout: 3500,
    // Phones: the bottom is where the Save/Cancel bar, focused input and keyboard sit,
    // so toasts go to the top where they only overlap a toolbar for a few seconds.
    position: Platform.is.mobile ? 'top' : 'bottom-left',
    classes: 'system-notify',
    actions: [{ icon: 'close', round: true, padding: 'xs', size: '12px' }],
    // If mobile, use default setting, else force false
    multiLine: Platform.is.mobile ? undefined : false
  })

  /* Mixins */
  app.mixin(globals)
  app.config.globalProperties.$loading = Loading
  app.config.globalProperties.$bus = Bus
  app.config.globalProperties.$unsubscribed = UnsubscribedDialog
  if (!Platform.is.nativeMobile) {
    app.config.globalProperties.$stripe = window.Stripe(process.env.STRIPE_KEY)
  }
  // Override quasar implementation of dialog with our custom one
  app.config.globalProperties.$q.dialog = Dialog

  /* Components */
  app.component('Beta', Beta)
  app.component('PageLayout', PageLayout)
  app.component('PageDrawer', PageDrawer)
  app.component('PageSidebar', PageSidebar)
  app.component('PageToolbarTitle', PageToolbarTitle)
  app.component('PageBanner', PageBanner)
  app.component('AddressField', AddressField)
  app.component('PhoneNumber', PhoneNumber)
  app.component('EmailAddress', EmailAddress)
  app.component('WidgetCard', WidgetCard)
  app.component('MorphFab', MorphFab)
  app.component('AccountingProvider', AccountingProvider)
  app.component('MiraIcon', MiraIcon)
  app.component('MiraLogo', MiraLogo)
  app.component('PaymentCards', PaymentCards)
  app.component('ProfileImage', ProfileImage)
  app.component('DetailItem', DetailItem)
  app.component('Date', Date)
  app.component('DocumentType', DocumentType)
  app.component('CancelButton', CancelButton)
  app.component('FileViewCard', FileViewCard)
  app.component('FileEditCard', FileEditCard)
  app.component('ColorPicker', ColorPicker)
  app.component('ColorField', ColorField)
  app.component('CheckboxList', CheckboxList)
  app.component('Timezones', Timezones)
  app.component('QSelectColorItem', QSelectColorItem)
  app.component('MultiSelect', MultiSelect)
  app.component('QBtnToggleColor', QBtnToggleColor)
  app.component('QItemWrapper', QItemWrapper)
  app.component('MinutePicker', MinutePicker)
  app.component('RruleDialog', RruleDialog)
  app.component('DatePicker', DatePicker)
  app.component('TimePicker', TimePicker)
  app.component('CountryPicker', CountryPicker)
  app.component('ContentDialog', ContentDialog)
  app.component('MessageDialog', MessageDialog)
  app.component('StickyHeader', StickyHeader)
  app.component('NoResults', NoResults)
  app.component('LoadingSpinner', LoadingSpinner)
  app.component('ValidatePassword', ValidatePassword)
  app.component('ClickableItem', ClickableItem)
  app.component('TextEditor', TextEditor)
  app.component('HelpButton', HelpButton)
  app.component('WidthAwareContainer', WidthAwareContainer)
  app.component('BasicLink', BasicLink)
  app.component('SignaturePad', SignaturePad)
  app.component('Timeline', Timeline)
  app.component('SimpleTimeline', SimpleTimeline)
  app.component('Tip', Tip)
  app.component('Articles', Articles)
  app.component('HtmlDialog', HtmlDialog)
  app.component('TwoPanelSplit', TwoPanelSplit)
  app.component('FocusView', FocusView)
  app.component('FocusContainer', FocusContainer)
  app.component('FocusField', FocusField)
  app.component('Nl2br', Nl2br)
  app.component('Constraint', Constraint)
  app.component('ResponsiveMenu', ResponsiveMenu)
  app.component('StackedBtn', StackedBtn)
  app.component('QPassword', QPassword)

  /* Module-specific components */
  // Appointments
  app.component('AppointmentSelectDialog', AppointmentSelectDialog)
  app.component('AppointmentInputPopover', AppointmentInputPopover)
  app.component('AppointmentItem', AppointmentItem)
  // Clients
  app.component('ClientItem', ClientItem)
  app.component('ClientInputPopover', ClientInputPopover)
  app.component('ClientChip', ClientChip)
  // Users
  app.component('UserItem', UserItem)
  app.component('UserInput', UserInput)
  app.component('UserInputPopover', UserInputPopover)
  app.component('UserChip', UserChip)
  // Reports
  app.component('ReportItem', ReportItem)
  // Invoices
  app.component('InvoiceItem', InvoiceItem)
  app.component('InvoiceInputPopover', InvoiceInputPopover)
  app.component('InvoiceChip', InvoiceChip)
  // Quotations
  app.component('QuotationItem', QuotationItem)
  // Forms
  app.component('FormItem', FormItem)
  // Licences
  app.component('LicenceItem', LicenceItem)
  // Files
  app.component('FileSelectDialog', FileSelectDialog)
  app.component('UploaderBtn', UploaderBtn)
  // Taxes and ledgers
  app.component('TaxTypeSelect', TaxTypeSelect)
  app.component('LedgerSelect', LedgerSelect)
  // Tables
  app.component('InfoTable', InfoTable)
  app.component('DynamicTable', DynamicTable)
  // Metadata
  app.component('MetadataViewList', MetadataViewList)
  app.component('MetadataEditList', MetadataEditList)

  /* External Components */
  app.use(VueSignaturePad)
  app.use(VuePapaParse)
  app.use(PortalVue)
  app.component('Skycon', Skycons)
  app.use(VueReCaptcha, {
    siteKey: process.env.RECAPTCHA3_KEY
  })
}
